import { sosHttpInstance } from './httpClient';
import { ALERT_ENDPOINTS } from '@/constants/apiEndpoints';

export const sosAlertListApi = async (body) => {
  const response = await sosHttpInstance.post(
    ALERT_ENDPOINTS.LIST + '?page=' + body.page + '&size=50',
    body,
  );
  return response.data;
};

export const sosCloseAlertApi = async (alertId) => {
  const response = await sosHttpInstance.put(
    ALERT_ENDPOINTS.CLOSE + '?alertId=' + alertId,
  );
  return response;
};

export const alertSummary2Api = async (resourceId, body) => {
  const response = await sosHttpInstance.post(
    '/meta-data/alert-details/alertData-v2?alertId=' + resourceId,
    body,
  );

  return response.data;
};

export const alertSummaryApi = async (alertId) => {
  const response = await sosHttpInstance.get(ALERT_ENDPOINTS.HEAD + alertId);
  return response.data;
};
